import { BaseVisual } from "../../../../visuals/BaseVisual";
import * as THREE from "three";
import { C4Agent } from "../C4Agent";
export class Interceptor {
  public active: boolean = true;
  public verticalDuration = 2.5; // seconds to reach target height
  public acceleration = 8.0; // m/s^2
  public speed = 0.0; // current speed in m/s
  public direction = new THREE.Vector3(0, 0, 1);
  public path: THREE.Vector3[] = [];
  public dA = 1.5; // angualar velocity in radians per second
  
  public trajectory = new THREE.Line(
    new THREE.BufferGeometry(), 
    new THREE.LineBasicMaterial({ color: 0xff0000 })
  );

  public head = new THREE.Mesh(
    new THREE.SphereGeometry(1.5, 8, 8),
    new THREE.MeshBasicMaterial({
      color: 0xff0000,
      transparent: true,
      opacity: 0.75
    })
  );

  constructor(public target: BaseVisual, public c4: C4Agent, public onDestroy: (t: BaseVisual) => void) {
    // Initialization code
    this.head.position.copy(this.c4.visual.position);
    this.c4.visual.obj.parent!.add(this.head);
    this.c4.visual.obj.parent!.add(this.trajectory);
  }

  public intercept(data: any): any {
    // Interception logic
    return data;
  }

  public render(delta: number): void {
    // Rendering logic
    if (!this.active) return;
    if (this.verticalDuration < 0) {
      const toTarget = this.target.obj.position.clone().sub(this.head.position);
      toTarget.normalize();
      this.direction.lerp(toTarget, this.dA * delta);
      this.direction.normalize();
    }

    this.speed += this.acceleration * delta;
    const move = this.direction.clone().multiplyScalar(this.speed * delta);
    this.head.position.add(move);
    this.path.push(this.head.position.clone());
    // render path
    if (this.path.length > 1) {
      this.trajectory.geometry.dispose();
      this.trajectory.geometry = new THREE.BufferGeometry().setFromPoints(this.path);
    }

    this.verticalDuration -= delta;
    if (this.verticalDuration <= 0) {
      this.acceleration = 0;
    }

    const distanceToTarget = this.head.position.distanceTo(this.target.obj.position);
    if (distanceToTarget < 2.5) {
      // Reached target
      this.active = false;
      this.head.removeFromParent();
      this.trajectory.removeFromParent();
      this.onDestroy(this.target);
    }
      // Optionally, trigger explosion or effect here
  }
}